import axios from "axios";
//esto se debe cambiar antes de actualizar el build y subir a produccion.
//const API_URL = "https://cmx.unilimpio.com/index.php/api/";
//const API_URL = "http://cmxbk/index.php/api/";


const API_URL = process.env.REACT_APP_API_URL;


const register = ( email, password) => {
  return axios.post(API_URL + "register", {
   
    email,
    password,
  });
};

const login = (email, password) => {

  return axios
    .post(API_URL + "login", {
      email,
      password,
    })
    .then((response) => {
      if (response.data.email) {
        localStorage.setItem("cmx_user", JSON.stringify(response.data));
      }

      return response.data;
    });
};

const guestLogin = (email, password) => {

  return axios
    .post(API_URL + "login", {
      email,
      password,
    })
    .then((response) => {
      if (response.data.email) {
        localStorage.setItem("user", JSON.stringify(response.data));
      }

      return response.data;
    });
};

const logout = () => {

  const user = getCurrentUser();
  
  if(typeof user !== "undefined"){ 
    return axios
      .get(API_URL + "logout", { headers: {"Authorization" : `Bearer ${user?.token}`} })
      
      .then((response) => {

        console.log(response)
                   
        localStorage.removeItem("cmx_user"); 
        localStorage.removeItem("cmx_flashMessage");
        localStorage.removeItem("cmx_compliance_ubId_selected");  
        
        return response;
        
      })
      .catch((error) => {
        
        if(error.message.includes('401')){

          localStorage.removeItem("cmx_user");
          localStorage.removeItem("cmx_flashMessage");
          localStorage.removeItem("cmx_compliance_ubId_selected");  
        }
      })
  
  } 
    
    
  
  
  
};

const getCurrentUser = () => {

  const user = localStorage.getItem("cmx_user");
  
  if(!user){
    return null;
  } else {

    if (user.exp < Date.now()){
      //removeCurrentUser();
      localStorage.removeItem("cmx_user");
      return null;
    }

    return JSON.parse(user);    
  }
  
    
};

const removeCurrentUser = () => {

  
  if(!localStorage.getItem("user")){
    return null;
  } else {
    return localStorage.removeItem("user");    
  }
  
    
};

const AuthService = {
  register,
  login,
  logout,
  getCurrentUser,
  removeCurrentUser
}

export default AuthService;
